'use strict'

import ApiClient from './ApiClient'

export default class NoImageRepository {
  /**
   * 画像未登録名刺を取得します。
   * @param options
   */
  getList (params) {
    return ApiClient().get(`/bcards-noimage`, {params: params})
  }

  /**
   * 指定されたIDの名刺情報を取得します。
   * @param {string|int} bcard_id 名刺ID
   * @returns {*}
   */
  get (bcard_id) {
    return ApiClient().get(`/bcards-noimage/${bcard_id}`)
  }

  /**
   * 指定されたIDの名刺情報へ名刺画像を登録します。
   * @param {string|int} bcard_id 名刺ID
   * @param {object} formData フォームデータ
   * @returns {*}
   */
  postImage (bcard_id, formData) {
    return ApiClient().post(`/bcards-noimage/${bcard_id}/images`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * 画像未登録名刺をCSVファイルにエクスポートします。
   * @param {object} formData フォームデータ
   * @returns {*}
   */
  postExport (formData) {
    return ApiClient().post(`/bcards-noimage/export`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * 画像未登録名刺エクスポートファイルをダウンロードします。
   * @param {object} options
   * @returns {*}
   */
  getExport (options) {
    return ApiClient().get(`/bcards-noimage/export`, options)
  }

  /**
   * 画像未登録名刺エクスポートの処理結果を取得する。
   * @returns {*}
   */
  getExportResult () {
    return ApiClient().get(`/bcards-noimage/export-result`)
  }

  /**
   * 画像未登録名刺エクスポートを停止する。（キャンセルファイルを作成する。）
   * @returns {*}
   */
  cancelExport () {
    return ApiClient().post(`/bcards-noimage/export-cancel`)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/NoImageRepository.js